export default __webpack_public_path__ + "static/media/6.da73c9b7.webp";